import React from 'react';
import { ScrollView, Text, TouchableOpacity, View, useWindowDimensions } from 'react-native';
import { ThemeColors } from '@/src/context/ThemeContext';
import { BlogPost } from '@/src/domain/models/BlogPost';
import { useTranslation } from '@/src/i18n';
import { createStyles } from './BlogPostScreen.styles';

export interface BlogPostScreenProps {
  post: BlogPost;
  colors: ThemeColors;
  onBack: () => void;
}

export const BlogPostScreen: React.FC<BlogPostScreenProps> = ({ post, colors, onBack }) => {
  const { width } = useWindowDimensions();
  const isWide = width >= 768;
  const styles = createStyles(isWide);
  const { t, language } = useTranslation();

  const displayTitle = language === 'es' ? post.titleEs : post.title;

  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr + 'T00:00:00');
    return date.toLocaleDateString(language === 'es' ? 'es-ES' : 'en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  const ContentComponent =
    language === 'es' && post.ContentEs ? post.ContentEs : post.Content;

  return (
    <ScrollView
      style={[styles.container, { backgroundColor: colors.background }]}
      contentContainerStyle={styles.scrollContent}
    >
      <TouchableOpacity style={styles.backBtn} onPress={onBack}>
        <Text style={[styles.backText, { color: colors.primary }]}>{t('blog.backToBlog')}</Text>
      </TouchableOpacity>

      <Text style={[styles.postTitle, { color: colors.text }]}>{displayTitle}</Text>

      <Text style={[styles.postDate, { color: colors.textTertiary }]}>
        {formatDate(post.date)}
      </Text>

      <View style={styles.tagsRow}>
        {post.tags.map((tag) => (
          <View key={tag} style={[styles.tagPill, { borderColor: colors.primary }]}>
            <Text style={[styles.tagText, { color: colors.primary }]}>{tag}</Text>
          </View>
        ))}
      </View>

      <View style={[styles.divider, { backgroundColor: colors.divider }]} />

      <ContentComponent colors={colors} />
    </ScrollView>
  );
};
